const thingList = [
  {
    type: "Hardware",
    subCategory: "Computer",
    name: "M2 Macbook Air 2022",
    spec: "M2 Chip. 16GB RAM. 256GB SSD.",
    text: "It never slows down and I can use it anywhere I want.",
  },
  {
    type: "Hardware",
    subCategory: "Computer",
    name: "Custom PC",
    spec: "Ryzen 5 3600@3.6Ghz. 16GB RAM. 512GB SSD. AMD RX570.",
    text: "First ever custom PC. Built from scratch and installed Arch Linux right away. Next custom built will be an SFF 10/10.",
  },
  {
    type: "Hardware",
    subCategory: "Mobile",
    name: "Iphone 14 Pro",
    spec: "6GB RAM. 256GB Storage. iOS.",
    text: "I had outgrown my Iphone 12 in terms of performance and battery life. This one is a beast.",
  },
  {
    type: "Hardware",
    subCategory: "Keyboard",
    name: "GMK67",
    spec: "65% Mech. Olivia Keycaps. Outemu Brown Switches.",
  },
  {
    type: "Hardware",
    subCategory: "Mice",
    name: "Logitech MX Master 3S",
    spec: "-",
  },
  {
    type: "Hardware",
    subCategory: "Watch",
    name: "Apple Watch Ultra",
    spec: "49mm. Titanium.",
  },
  {
    type: "Hardware",
    subCategory: "IEM",
    name: "Blon BL-03",
    spec: "IEMs with 10mm dynamic driver that sound awesome",
  },
  {
    type: "Hardware",
    subCategory: "Headphones",
    name: "Sony WH-1000XM4",
    spec: "Noise Cancelling Over the Ear Headphones",
  },
  {
    type: "Hardware",
    subCategory: "Earphones",
    name: "Apple AirPods Pro",
    spec: "AirPods Pro 2nd Gen",
    text: "When I got the AirPods, I didn't know it was going to be such a boost to convenience. Coupled with my Macbook, this probably is the best earphones to join a call anytime from anywhere.",
  },
  {
    type: "Hardware",
    subCategory: "Speaker",
    name: "Google Nest Audio",
    spec: "Smart Speaker.",
  },
  {
    type: "Software",
    subCategory: "OS",
    name: "MacOS / Arch Linux",
    spec: "i3 gaps. Picom. Rofi. Polybar. Termite. ZSH.",
  },
  {
    type: "Software",
    subCategory: "Editor",
    name: "VSCode",
    spec: "Dark Horizon Theme. Material Icon Theme as Icon Pack.",
  },
  {
    type: "Software",
    subCategory: "Extras",
    name: "Other tools",
    spec: "Spotify. Chrome. Google Keep.",
  },
];

export default thingList;
